import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '@shared/services/loader.service';
import { TransactionService } from '@shared/services/transaction.service';
import { PaymentService } from '../../services/payment.service';
import { UpdatecardpageComponent } from '../updatecardpage/updatecardpage.component';

@Component({
    selector: 'app-continue-page-update',
    templateUrl: './continue-page-update.component.html',
    styleUrls: ['./continue-page-update.component.css'],
    standalone: false
})
export class ContinuePageUpdateComponent {
  jwtCardinal: string = '';
  private token: string = '';
  private cardBin: string = '';
  private expirationDate: string = '';
  binCard: string = '';
  cardExpirationDate: string = '';
  formattedMaskedValue: string = '';
  backToCardForm: boolean = false;
  public phoneNumber: string | null = '';
  public errorproceso: Boolean = false;

  constructor(
    private _loaderService: LoaderService,
    private cdr: ChangeDetectorRef,
    private _transactionService: TransactionService,
    private route: ActivatedRoute,
    private router: Router,
    public _paymentService: PaymentService,
    // private updatecardpage: UpdatecardpageComponent
  ){

  }

  ngOnInit(): void{
    this.phoneNumber = localStorage.getItem('phoneNumber');

  }

  formatMaskedValue(maskedValue: string, bin: string): string {
    const firstFourBin = bin.slice(0, 4); // Obtener los primeros 4 dígitos del bin
    const lastDigits = maskedValue.slice(-4); // Obtener los últimos 4 dígitos del maskedValue
    const maskedSection = '*'.repeat(maskedValue.length - 8); // Crear los asteriscos para la sección enmascarada

    return `${firstFourBin}${maskedSection}${lastDigits}`;
  }

//  async pinpageupdate(){
//     // this.router.navigate(['pinpage']);
//     try {
//       const resultUbindCard = await this.unbindCard(
//         this._paymentService.bodyrequestcard
//       );
//       console.log(resultUbindCard);
//       if (resultUbindCard.resultCode === 'SUCCESS') {
//         console.log(this._paymentService.email);
//         this._paymentService.finishpin = false;
//         this.router.navigate(['/confirmationDAM']);
//       }else{
//         this._loaderService.hideLoading();
//         this.errorproceso = true;
//         setTimeout(() =>{
//           this.errorproceso = false;
//         }, 5000);
//         this._paymentService.finishpin = true;
//         this.router.navigate(['/confirmationDAM']);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   }



  // async updateCardService() {
  //   try {
  //     const resultUbindCard = await this.unbindCard(
  //       this._paymentService.bodyrequestcard
  //     );
  //     console.log(resultUbindCard);
  //     if (resultUbindCard.resultCode === 'SUCCESS') {
  //       console.log(this._paymentService.email);
  //       this._paymentService.finishpin = false;
  //       this.router.navigate(['/confirmationDAM']);
  //     } else {
  //       console.log('ERROR RESULTADO NO EXITOSO');
  //       this._paymentService.finishpin = true;
  //       this.router.navigate(['/confirmationDAM']);
  //     }
  //   } catch (error) {
  //     console.log('ERROR GENERAL AL ACTUALIZAR TARJETA');
  //     this._paymentService.finishpin = true;
  //     this.router.navigate(['/confirmationDAM']);
  //   }
  // }

  // unbindCard(bodyRequest?: any): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     const extractedData = {
  //       rfc: this._paymentService.numberphone,
  //       toke_numero: this._paymentService.tokeNumero,
  //       transientToken: bodyRequest.transientToken,
  //       captureContext: bodyRequest.captureContext,
  //     };

  //     this._paymentService.unbindCardPayment(extractedData).subscribe(
  //       (transactionSummary) => {
  //         console.log(extractedData);
  //         const { resultCode, result } = transactionSummary;
  //         console.log(resultCode, result);
  //         console.log(transactionSummary);

  //         if (transactionSummary.errorCode) {
  //           this._paymentService.setIsNational(false);
  //         }
  //         resolve(transactionSummary);
  //       },
  //       (error) => {
  //         reject(error);
  //       }
  //     );
  //   });
  // }


  goBack(){
    this._paymentService.numbermodule = 0;
  }


}
